import React from 'react';
import classnames from 'classnames';

import { ButtonProps } from '../types';
import './tabHeader.scss';

type TabHeaderProps = {
  active: boolean;
} & ButtonProps;

export const TabHeader: React.FC<TabHeaderProps> = ({ title, active, onClick, ...rest }) => {
  const classes = classnames('tab-button', active && 'tab-button__active');
  return (
    <button className={classes} onClick={onClick} {...rest}>
      {title}
    </button>
  );
};
